import { IUserRejected } from '../../../actions/userAccount/user/fetchUser'
import { IUserAccountStore } from '../index'

export default function(
  state: IUserAccountStore,
  action: IUserRejected,
): IUserAccountStore {
  return {
    ...state,
    request: {
      ...state.request,
      errMessage: action.errMessage,
      isLoading: false,
    },
  }
}
